import { useLanguage } from './setGetLanguage';
import { useUserData } from './updateUserData';
import { useSettings } from './updateSettings';
import { logoutUser, cancelTrace } from '../api/api';
import i18n from "i18next";
import { useRef, useCallback } from 'react';

export function useResetUserDataAndLanguage() {
  const { userData, setUserData } = useUserData();
  const { setSettings } = useSettings();
  const { setLanguage } = useLanguage();
  const loggedOutRef = useRef(false); // persist across renders
  const canceledTraceRef = useRef(false);

  const reset = useCallback(async () => {
    try {
      if (userData?.tokens?.access_token && !loggedOutRef.current) {
        loggedOutRef.current = true;  // mark as logged out
        await logoutUser(userData.tokens.access_token);
        // console.log("Logout successful:", response);
      }
      if (userData?.headlineData && !canceledTraceRef.current){
        canceledTraceRef.current = true;
        await cancelTrace(userData.tokens.access_token, userData.headlineData.trace_id);
        // console.log("Logout successful:", response);
      }
    } catch (err) {
      console.error(err.message);
    } finally {
      setUserData({});
      setSettings({"text_size": 1, "text_speed": 1});
      setLanguage("_en");
      i18n.changeLanguage("en");
      sessionStorage.setItem("chapterIndex", 0);
    }
  }, [userData, setUserData, setSettings, setLanguage]);

  return reset;
}